const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const aggregateRecordsByDay = (nodeData = {}, extractor) => {
  if (!nodeData || typeof nodeData !== "object") return {};
  return Object.entries(nodeData).reduce((acc, [day, records]) => {
    const dayNumber = Number(day);
    if (!Number.isFinite(dayNumber) || !records || typeof records !== "object") {
      return acc;
    }
    const totals = Object.values(records).reduce(
      (rowTotals, record) => {
        const metrics = extractor(record);
        return {
          liters: rowTotals.liters + toNumber(metrics.liters),
          amount: rowTotals.amount + toNumber(metrics.amount),
        };
      },
      { liters: 0, amount: 0 }
    );
    acc[dayNumber] = totals;
    return acc;
  }, {});
};

export const buildTrendAndTotals = (milkCollectedByDay = {}, milkSoldByDay = {}) => {
  const collectedTotalsByDay = aggregateRecordsByDay(milkCollectedByDay, (record) => ({
    liters: record?.TotalKgs,
    amount: record?.TotalCost,
  }));
  const soldTotalsByDay = aggregateRecordsByDay(milkSoldByDay, (record) => ({
    liters: record?.quantity ?? record?.liters,
    amount:
      record?.totalAmount ??
      toNumber(record?.unitPrice ?? record?.UnitPrice) *
        toNumber(record?.quantity ?? record?.liters),
  }));

  const allDays = Array.from(
    new Set([
      ...Object.keys(collectedTotalsByDay).map(Number),
      ...Object.keys(soldTotalsByDay).map(Number),
    ])
  ).sort((a, b) => a - b);

  const trendData = allDays.map((day) => ({
    label: `Day ${day}`,
    collection: collectedTotalsByDay[day]?.liters || 0,
    sales: soldTotalsByDay[day]?.liters || 0,
  }));

  const monthlyTotals = {
    collection: Object.values(collectedTotalsByDay).reduce(
      (sum, item) => sum + (item?.liters || 0),
      0
    ),
    sales: Object.values(soldTotalsByDay).reduce(
      (sum, item) => sum + (item?.liters || 0),
      0
    ),
    payout: Object.values(collectedTotalsByDay).reduce(
      (sum, item) => sum + (item?.amount || 0),
      0
    ),
    receipts: Object.values(soldTotalsByDay).reduce(
      (sum, item) => sum + (item?.amount || 0),
      0
    ),
  };

  return { trendData, monthlyTotals };
};
